/**
 * SKU表单 - 供应商与状态（舒适布局版）
 * 职责: 供应商信息、产品状态、包装信息
 */

import React from 'react';
import { Form, Input, InputNumber, Select, DatePicker, Row, Col, Divider, Space } from 'antd';

const { Option } = Select;

export const SKUFormSupplierFields: React.FC = () => {
    return (
        <>
            <Divider orientation="left" style={{ margin: '0 0 24px', fontWeight: 600, fontSize: 16 }}>生命周期</Divider>

            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item name="status" label="当前状态" initialValue="developing" style={{ marginBottom: 24 }}>
                        <Select>
                            <Option value="developing">开发中</Option>
                            <Option value="sample">样品测试</Option>
                            <Option value="active">在售</Option>
                            <Option value="inactive">停售</Option>
                            <Option value="clearance">清仓</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name="launch_date" label="首次上架日期" style={{ marginBottom: 24 }}>
                        <DatePicker style={{ width: '100%' }} placeholder="选择日期" />
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" style={{ margin: '12px 0 24px', fontWeight: 600, fontSize: 16 }}>供应链</Divider>

            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item name="supplier_name" label="供应商名称" style={{ marginBottom: 24 }}>
                        <Input placeholder="供应商名称" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="supplier_sku" label="供应商SKU" style={{ marginBottom: 24 }}>
                        <Input placeholder="厂家货号" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item name="lead_time_days" label="采购周期(天)" tooltip="下单到收货" style={{ marginBottom: 24 }}>
                        <InputNumber style={{ width: '100%' }} min={0} placeholder="天数" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name="moq" label="起订量(MOQ)" style={{ marginBottom: 24 }}>
                        <InputNumber style={{ width: '100%' }} min={1} placeholder="数量" />
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" style={{ margin: '12px 0 24px', fontWeight: 600, fontSize: 16 }}>外箱规格</Divider>

            <Row gutter={24}>
                <Col span={18}>
                    <Form.Item label="外箱尺寸 (长x宽x高)" style={{ marginBottom: 24 }}>
                        <Space.Compact style={{ width: '100%' }}>
                            <Form.Item name="package_length" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="长" precision={1} min={0} />
                            </Form.Item>
                            <Input style={{ width: '5%', borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff', textAlign: 'center' }} placeholder="x" disabled />
                            <Form.Item name="package_width" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="宽" precision={1} min={0} />
                            </Form.Item>
                            <Input style={{ width: '5%', borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff', textAlign: 'center' }} placeholder="x" disabled />
                            <Form.Item name="package_height" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="高" precision={1} min={0} />
                            </Form.Item>
                        </Space.Compact>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="units_per_carton" label="装箱数" tooltip="每箱数量" style={{ marginBottom: 24 }}>
                        <InputNumber style={{ width: '100%' }} min={1} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item name="package_weight" label="整箱重量(kg)" style={{ marginBottom: 24 }}>
                        <InputNumber style={{ width: '100%' }} precision={2} min={0} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
